// All landing-page CTAs route through this single URL. Configure in .env:
//   REACT_APP_LANDING_CTA_URL=https://your-portal-host
// If unset, falls back to the dev portal so behavior is unchanged
// for local dev without a configured destination.
const PORTAL_FALLBACK = process.env.REACT_APP_PORTAL_URL || 'http://localhost:3001';

// Derive the portal's origin (scheme + host) from REACT_APP_LANDING_CTA_URL
// when it's set, so a single env var configures every portal-bound link.
// We accept either a bare host like `https://doctoradmin.momentsview.tech`
// or a full URL with a trailing path like `.../register` — both yield the
// same origin.
function portalOrigin() {
  const raw = process.env.REACT_APP_LANDING_CTA_URL;
  if (raw) {
    try { return new URL(raw).origin; } catch { /* fall through */ }
  }
  try { return new URL(PORTAL_FALLBACK).origin; } catch { return PORTAL_FALLBACK; }
}

const PORTAL = portalOrigin();

// Primary CTA destination. If REACT_APP_LANDING_CTA_URL is a full URL with
// a path (e.g. `.../register`) we honour it verbatim; otherwise we append
// `/register` for the signup screen.
export const LANDING_CTA_URL = (() => {
  const raw = process.env.REACT_APP_LANDING_CTA_URL;
  if (!raw) return `${PORTAL}/register`;
  try {
    const u = new URL(raw);
    return u.pathname && u.pathname !== '/' ? raw : `${u.origin}/register`;
  } catch {
    return `${PORTAL}/register`;
  }
})();

export const LANDING_SIGNIN_URL = `${PORTAL}/login`;
export const PORTAL_DASHBOARD_URL = `${PORTAL}/dashboard`;
export const PORTAL_LOGOUT_URL = `${PORTAL}/logout`;
// Portal page where a signed-in user can copy & share their referral link.
export const PORTAL_REFERRALS_URL = `${PORTAL}/referrals`;
// Clinic / staff / admin login. The access code is entered inline on
// the portal-login page itself (no `?code=` query needed).
export const PORTAL_CLINIC_SIGNIN_URL = `${PORTAL}/portal-login`;

// Build a portal-login URL that returns the user to a landing-page URL
// (absolute) after successful login. The portal's login pages detect
// absolute `from` values and use window.location.href to hop cross-origin.
export function loginReturnToLanding(returnPath = '/') {
  if (typeof window === 'undefined') return `${PORTAL}/login`;
  const returnUrl = `${window.location.origin}${returnPath.startsWith('/') ? returnPath : `/${returnPath}`}`;
  return `${PORTAL}/login?from=${encodeURIComponent(returnUrl)}`;
}
